// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as RaiseTicketCmp from "./RaiseTicketCmp.bs.js";

function OrderRelatedTicketRootCmp(Props) {
  var crn = Props.crn;
  return React.createElement(RaiseTicketCmp.make, {
              crn: crn
            });
}

var make = OrderRelatedTicketRootCmp;

export {
  make ,
  
}
/* react Not a pure module */
